import '.bx{position:relative;}.ssr-plugin'
import '.i3{width:64px;}.ssr-plugin'
import '.i4{height:64px;}.ssr-plugin'
import '.c9{flex-shrink:0;}.ssr-plugin'
import '.o{position:absolute;}.ssr-plugin'
import '.i5{bottom:-4px;}.ssr-plugin'
import '.cg{right:-4px;}.ssr-plugin'
import '.d0{border-radius:50%;}.ssr-plugin'
import '.i6{border:2px solid var(--shades-white);}.ssr-plugin'
import '.s{overflow:hidden;}.ssr-plugin'
import '.i7{width:32px;}.ssr-plugin'
import '.i8{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="bx i3 i4 c9"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="o i5 cg d0 i6 s i7 i8"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
